module.exports = __webpack_public_path__ + "static/img/conversion.2dabe13c.jpg";